import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useState } from "react";
import { ReactComponent as CalendarIcon } from "svgs/light/calendar.svg";

interface IDatePickerProps {
  label: string;
  value: dayjs.Dayjs | null;
  onChange: (date: dayjs.Dayjs | null) => void;
  format?: any;
  minSelectableDate?: dayjs.Dayjs;
  maxDate?: dayjs.Dayjs;
  dateStyle?: any;
  disableFuture?: boolean;
  disablePast?: boolean;
  minDate?: dayjs.Dayjs | null;
  disabled?: boolean;
  className?: any;
}

function CustomDatePicker({
  label,
  value,
  format,
  onChange,
  minSelectableDate,
  maxDate,
  minDate,
  dateStyle,
  disableFuture,
  disablePast,
  disabled,
  className = {},
  ...props
}: IDatePickerProps) {
  const [open, setOpen] = useState<boolean>(false);

  const shouldDisableDate = (date: dayjs.Dayjs) => {
    if (!minSelectableDate) return false;
    return date < minSelectableDate;
  };

  const additionalProps = {
    ...(maxDate ? { maxDate } : {}),
    ...(minDate ? { minDate } : {}),
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        format={format || ""}
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          width: "100%",
          ".MuiOutlinedInput-notchedOutline": {
            // borderColor: "#A2A1A833",
            // borderRadius: "10px",
            height: "50px",
          },
          "&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "#A2A1A833",
              borderRadius: "10px",
              height: "50px",
            },

          "& .MuiOutlinedInput-input": {
            fontFamily: "Lexend",
            fontWeight: 300,
            fontSize: "14px",
            padding: "12px 14px",
          },

          ...dateStyle,
          ...className,
        }}
        value={value}
        onChange={onChange}
        slots={{
          openPickerIcon: () => <CalendarIcon />,
        }}
        slotProps={{
          textField: { placeholder: label, onClick: () => setOpen(true) },
        }}
        shouldDisableDate={shouldDisableDate}
        disablePast={disablePast}
        disabled={disabled}
        {...additionalProps}
        {...props}
      />
    </LocalizationProvider>
  );
}

export default CustomDatePicker;
